// i18n area 'hci' — locale en-GB (task #171, MODELLO DELTA): NON è un
// dizionario intero. Eredita da hci.en-US.ts e sovrascrive SOLO le chiavi
// che l'inglese britannico scrive davvero in un altro modo — una chiave nuova
// nella base arriva qui gratis, e la parità si misura su base + delta.
// Contenuto: ortografia britannica (-ise/-isation, 'licence' sostantivo,
// 'catalogue', 'centre', 'enrolment') e le poche differenze lessicali reali.
// Token che NON sono prosa (il riferimento catalog/<catalog>/<file>@<digest>,
// il permesso catalog.download) restano tali e quali.
// Sidecar anti-stantie: ../meta/hci.en-GB.meta.json.
import type { DeepPartial } from '../delta'
import type { enUS } from './hci'

export const enGB: DeepPartial<typeof enUS> = {
  hci: {
    ceph: {
      split: {
        enableBody: 'The MGR membership becomes independent from the MONs, initialised from the current colocation. The standalone Add/Remove MGR actions arm in the Management nodes tab. This relaxes the platform default — keep it only if you know why you need it.'
      },
      propose: {
        alsoProposePoolHint: 'After the creation the same gesture proposes the newborn pool as a ceph-rbd storage — two explicit calls, one dialogue.',
        alsoProposeFsHint: 'After the creation the same gesture proposes the newborn filesystem as a cephfs storage — two explicit calls, one dialogue.',
        started: 'Proposal accepted — the storage is being materialised; find it under Storage'
      }
    }
  }
}
